import { CREATE_ORGANIZATION_INTENT } from '../utils/onboardingPaths';

export function getDashboardHomeUrl(location = window.location) {
  const dashboardPath = location.pathname.startsWith('/dashboard') ? '/dashboard/' : '/';
  return `${location.origin}${dashboardPath}`;
}

export function getOrganizationActivationRedirectUrl({ flowMode, location = window.location }) {
  return flowMode === CREATE_ORGANIZATION_INTENT ? getDashboardHomeUrl(location) : undefined;
}

export function navigateAfterOrganizationCreation({
  flowMode,
  orgData,
  history,
  location = window.location,
}) {
  // Clerk normally owns this document navigation through setActive's redirectUrl.
  // Keep this as a fallback in case setActive resolves without unloading the page.
  if (flowMode === CREATE_ORGANIZATION_INTENT) {
    location.replace(getDashboardHomeUrl(location));
    return;
  }

  // First-time onboarding does not switch away from an existing tenant, so it
  // can keep the faster client-side handoff and seed the initial dashboard render.
  const merchantSeed = orgData
    ? {
        onboardingCurrentStep: 'invite_team_pre_form',
        organizationId: orgData.organizationId,
        merchantName: orgData.merchantName || '',
        // Stripped once GET /merchant replaces state; suppresses PreFormInvite until hydrated.
        __charitystackRouterSeed: true,
      }
    : undefined;

  history.push('/', { merchantSeed });
}
